function n(t) {
  const e = t.startsWith("#") ? t.slice(1) : t;
  return new URLSearchParams(e);
}
function a(t) {
  return t.get("state") ? !!(t.get("code") || t.get("error") || t.get("access_token")) : !1;
}
function r(t = window.location.href) {
  const e = new URL(t);
  return a(e.searchParams) || a(n(e.hash));
}
export {
  r as h
};
//# sourceMappingURL=oauth-callback-D1dy1GrA.js.map
